import { useRecovery } from '../context/RecoveryContext';

export function EmergencyAccessBanner(): JSX.Element | null {
  const { outbound, cancelEmergencyAccess } = useRecovery();
  const pending = outbound.find((c) => c.state === 'EMERGENCY_REQUESTED');
  if (!pending) return null;

  const releaseDate = pending.emergencyReleaseAt?.slice(0, 10) ?? 'unknown';

  return (
    <div className="bg-red-500/15 border-b border-red-500/30 text-red-300 px-4 py-2 flex items-center justify-between">
      <div className="text-sm">
        <strong>Emergency access requested.</strong>{' '}
        <span>
          {pending.contactEmail} will get read-only access to your safe on {releaseDate}.
        </span>
      </div>
      <button
        id="emergency-access-cancel-button"
        type="button"
        onClick={() => {
          void cancelEmergencyAccess(pending.contactUserId);
        }}
        className="text-sm font-semibold underline hover:text-red-100"
      >
        Cancel access
      </button>
    </div>
  );
}
